import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, ViewChild, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ClarityModule, ClrDatagrid } from '@clr/angular';
import dayjs from 'dayjs';
import { ToastService } from 'src/app/services/toast.service';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';

import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { ObjTypePipe } from 'src/app/pipes/objtype.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { APIService } from 'src/app/services/APIService/api.service';
import { PaintingComponent } from '../../_shared/paint/painting.component';
import { NewAuftragModel } from 'src/app/types/api';
import { Row } from 'src/app/models/ui/table';
import { DatalistInputComponent } from '../../_shared/datalist-input/datalist-input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-auftragdialog',
  templateUrl: './auftragdialog.component.html',
  styleUrls: ['./auftragdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    PaintingComponent,
    MrTranslatePipe,
    ObjTypePipe,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
    BackendLocaleDatePipe,
    DatalistInputComponent,
  ],
})
export class AuftragdialogComponent {
  private apiservice = inject(APIService);
  private toastr = inject(ToastService);
  private spinner = inject(SpinnerService);
  private authservice = inject(AuthService);
  private mrTranslate = inject(MrTranslatePipe);
  private overlayService = inject(OverlayService);
  protected localeDate = inject(BackendLocaleDatePipe);

  ostammid: number;
  typ_Line_Point: number;
  latlng: string;
  imgSrc: any;
  firmen: Array<any>;
  mangel: any;
  output: any = {};
  date: any;
  selected: Row[] = [];
  listih: any = [];
  tupleih: any = [];
  meh: any = [];

  trial = false;

  auftragsarten: Array<any>;
  result: Array<any>;
  openTab = 'mangel';
  isload: boolean = false;
  isStarting: boolean = false;
  Opt_F_Drawing: any;
  auftragsgroups: Array<any>;

  showaltInstandsetzung: boolean = false;
  selMangelRow: any;

  @ViewChild(ClrDatagrid) grid: ClrDatagrid;
  mapOptions = {
    center: {
      lat: 49.007252,
      lng: 8.414331,
    },
    zoom: 10,
    marker: [
      {
        lat: 49.008189,
        lng: 8.424115,
      },
    ],
  };
  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataRefresh = new EventEmitter();

  // public showAssignment: BehaviorSubject<Object> = new BehaviorSubject({});

  altMangelGroup = new UntypedFormGroup({
    omazsid: new UntypedFormControl(''),
    altvon: new UntypedFormControl(''),
    altbis: new UntypedFormControl(''),
    altinstandsetzungshinweis: new UntypedFormControl(''),
    altumfang: new UntypedFormControl(''),
    altmengeneinheit: new UntypedFormControl(''),
  });

  auftragGroup = new FormGroup({
    startdate: new FormControl('', [Validators.required]),
    enddate: new FormControl('', [Validators.required]),
    auftragnehmer: new FormControl<number>(null, [Validators.required]),
    auftragsart: new FormControl(''),
    auftragsgruppe: new FormControl(''),
    auftragsnr: new FormControl(''),
    bemerkung: new FormControl(''),
    gruppenid: new FormControl(1, [Validators.required]),
  });

  set data(dataIn: any) {
    this.ostammid = dataIn.id;
    this.typ_Line_Point = dataIn.typ_Line_Point;
    this.latlng = dataIn.latlng;
    this.Opt_F_Drawing = dataIn.Opt_F_Drawing;
    if (dataIn.dataRefresh) {
      this.dataRefresh = dataIn.dataRefresh;
    }

    this.apiservice
      .getAuftragsGroups()
      .pipe(first())
      .subscribe((res: any) => {
        if (res) {
          this.auftragsgroups = res.map(item => {
            return {
              id: item.id,
              mBezeichnung: `${item.Bezeichnung}`,
            };
          });
        }
      });

    this.getAuftragsarten();

    this.apiservice
      .getAnlagenAuftrag(this.ostammid, 0)
      .pipe(first())
      .subscribe((val: any) => {
        this.firmen = val.firmen;
        this.mangel = val.mangel;
        this.tupleih = val.listih;
        this.meh = val.meh;

        //Nicht anzeigen, wenn OSTAMMID im Mangel falsch ist.
        this.mangel.rows = this.mangel.rows.filter(mngl => this.ostammid == mngl.ostammid);

        this.isload = true;
      });
  }

  constructor() {
    const { auftragslaenge: laenge = 3, trial = false } = ({} = this.authservice.getToken());
    this.auftragGroup.controls.startdate.setValue(BackendLocaleDatePipe.now);
    this.auftragGroup.controls.enddate.setValue(dayjs().add(laenge, 'days').format(BackendLocaleDatePipe.format));
    this.trial = trial === true;
  }

  private async getAuftragsarten() {
    ({ auftragart: this.auftragsarten } = await firstValueFrom(this.apiservice.getNeuAuftraegWerte()));
  }

  tabChange(tab) {
    this.openTab = tab;
  }

  getAuftragsgruppeName(id: any) {
    let gruppe;
    if (this.auftragsgroups) gruppe = this.auftragsgroups.filter(item => item.id == id)[0]?.mBezeichnung;
    return gruppe || undefined;
  }

  editMangel() {
    let data = this.altMangelGroup.value;

    this.apiservice
      .setAlternativeInstandsetzung(data)
      .pipe(first())
      .subscribe(val => {
        if (val.success) {
          this.toastr.success(this.mrTranslate.transform('Eintrag erfolgreich gespeichert'));
          this.selMangelRow.altinstandsetzungshinweis = data.altinstandsetzungshinweis;
          this.selMangelRow.altumfang = data.altumfang;
          this.selMangelRow.altmengeneinheit = data.altmengeneinheit;
        }
        this.showaltInstandsetzung = false;
      });
  }

  onEdit(row: any) {
    this.selMangelRow = row;
    this.listih = this.tupleih.filter(d => d.Item1 === row.pruefart);
    this.altMangelGroup.controls.omazsid.setValue(row.OMAZSID);
    this.altMangelGroup.controls.altinstandsetzungshinweis.setValue(row.altinstandsetzungshinweis);
    this.altMangelGroup.controls.altumfang.setValue(row.altumfang);
    this.altMangelGroup.controls.altmengeneinheit.setValue(row.altmengeneinheit);

    if (row.altmengeneinheit == null && row.mengeneinheit != '') {
      this.altMangelGroup.controls.altmengeneinheit.setValue(row.mengeneinheit);
    }

    if (row.altumfang == null && row.umfang != '') {
      this.altMangelGroup.controls.altumfang.setValue(row.umfang);
    }

    this.showaltInstandsetzung = true;
  }

  protected async onSubmit() {
    if (this.auftragGroup.invalid) return;
    this.spinner.enable();

    try {
      const { gruppenid, ...auftrag } = this.auftragGroup.getRawValue();
      const sendObj: NewAuftragModel = {
        ...auftrag,
        strOMAZSID: this.selected.map(row => row.OMAZSID).join(' '),
        ostammid: this.ostammid,
        auftragsgruppe: gruppenid,
        titel: 'Instandsetzung',
        kostenart: '',
        language: localStorage.getItem('language'),
      };

      this.isStarting = true;
      const data = await firstValueFrom(this.apiservice.sendAuftrag(sendObj));

      if (data) {
        this.toastr.success(this.mrTranslate.transform('Eintrag erfolgreich gespeichert'));
        this.auftragGroup.reset();
        this.dataRefresh?.emit(true);
        this.overlayService.setOverlay({
          isTopOverlay: true,
          overlay: 'viewAuftrag',
          data,
          auftragsnr: sendObj.auftragsnr,
          zIndex: 5,
        });
      }
    } catch (_) {
      console.error(_);
    } finally {
      this.isStarting = false;
      this.spinner.disable();
    }
  }

  public close() {
    this.closedialog.next(true);
  }
}
